import getApiUrl from "../utils/apiUrl";
import fetch from "../utils/mgFetch";

const getEaccountingArticleUnits = (token: string, backend: string) => {
    return fetch(`${getApiUrl(backend)}eaccounting_article_units`, {
        method: "GET",
        headers: {
            Authorization: `Bearer ${token}`
        }
    }) 
}

export default getEaccountingArticleUnits